// hooks/useHorairesConfig.js
// Hook pour récupérer la configuration des horaires depuis l'API

import { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://www.klasys.com';

const useHorairesConfig = () => {
  const [horaireConfig, setHoraireConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    
    const fetchHoraires = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE_URL}/api/variable-elements/config/horaires`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Erreur ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();
        
        if (isMounted && result.success) {
          setHoraireConfig(result.data);
        } else if (isMounted) {
          throw new Error(result.message || 'Erreur lors de la récupération des horaires');
        }
      } catch (err) {
        if (isMounted) {
          console.error('Erreur horaires config:', err);
          setError(err.message);
          // Valeurs par défaut en cas d'erreur
          setHoraireConfig({
            horaires_ecole_debut: '07:00',
            horaires_ecole_fin: '17:00',
            pause_dejeuner_debut: '12:00',
            pause_dejeuner_fin: '14:00',
            tolerance_retard_minutes: 15,
            seuil_absence_minutes: 60,
            jours_actifs: {
              lundi: true,
              mardi: true,
              mercredi: true,
              jeudi: true,
              vendredi: true,
              samedi: false,
              dimanche: false
            }
          });
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchHoraires();
    
    return () => {
      isMounted = false;
    };
  }, []);

  return { horaireConfig, loading, error };
};


export default useHorairesConfig;